<template>
  <Layout header-class="header-left-align " nav-alignment="left">
    <BlogBanner :lead="$t('Blog.breadcrumb_url')" />

    <div class="rn-blog-area rn-section-gap">
      <div class="container">
        <div class="row row--30">
          <div class="col-lg-8">
            <div class="row mt_dec--30">
              <div class="col-lg-12">
                <div class="row row--15">
                  <div class="col-lg-12 mt--30" data-aos="slide-up" data-aos-duration="800"
                    :data-aos-delay="100 + index" v-for="(blog, index) in filteredPosts" :key="blog.id">
                    <BlogPost :blog="blog" blog-post-style="list" />
                  </div>
                  <p v-if="!filteredPosts.length" class="col-lg-12 mt--30" role="status">
                    {{ $t('Blog.no_results') }}
                  </p>
                </div>
              </div>
              <div v-if="!searchQuery" class="col-lg-12 text-center">
                <div class="rwt-load-more text-center mt--60">
                  <router-link class="btn-default" to="/category/all"> {{ $t('Blog.view_more_post') }} </router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-4 mt_md--40 mt_sm--40">
            <BlogSidebar @search-input="searchQuery = $event" />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Icon from '../../components/icon/Icon'
import BlogPost from '../../components/blog/BlogPost'
import Layout from '../../components/common/Layout'
import BlogBanner from '../../components/blog/BlogBanner'
import BlogSidebar from '../../components/blog/BlogSidebar'
import BlogPostMixin from '../../mixins/BlogPostMixin'

export default {
  name: 'BlogListSidebarPage',
  components: { BlogSidebar, Icon, BlogPost, Layout, BlogBanner },
  mixins: [BlogPostMixin],
  data() {
    return {
      searchQuery: ''
    }
  },
  watch: {
    '$route.query.q': {
      immediate: true,
      handler(query) {
        this.searchQuery = typeof query === 'string' ? query : ''
      }
    }
  },
  computed: {
    filteredPosts() {
      const query = this.searchQuery.trim().toLocaleLowerCase()
      if (!query) return this.posts

      return this.posts.filter((post) => {
        const categories = post.categories.map((category) => this.$t(`Blog.categories.${category}`))
        const tags = post.tags.map((tag) => this.$t(`Blog.tags.${tag}`))
        const content = [post.title, post.body, ...categories, ...tags].join(' ')
        return content.toLocaleLowerCase().includes(query)
      })
    },
    userLogin() {
      return this.$store.state.userLogin
    }
  }
}
</script>
<style>
.background-1-blog-light {
  background-image: url(../../assets/images/Newlandindpage/lightmode/bg-blog.png);
  background-size: cover;
  background-position: -0% 40%;
  background-repeat: no-repeat;
  /* background-position: right; */
  z-index: 2;
  width: 100%;
  height: 100%;
}
</style>
